import { useState } from "react";
import { PrimaryButton } from "@normasteaching/norma-ui";
import { OverlayDialog } from "../../UI/Modal/OverlayDialog.tsx";

function ordersLabel(count: number): string {
  return count === 1 ? "1 ordine" : `${count} ordini`;
}

function describeSelection({
  search,
  hasFilters,
  allOrdersDescription,
}: {
  search?: string;
  hasFilters: boolean;
  allOrdersDescription: string;
}): string {
  const trimmedSearch = search?.trim();
  if (!trimmedSearch && !hasFilters)
    return `Nessuna ricerca né filtro attivo: vengono esportati ${allOrdersDescription}.`;
  const criteria = [
    trimmedSearch && `alla ricerca «${trimmedSearch}»`,
    hasFilters && "ai filtri attivi",
  ].filter(Boolean);
  return `Vengono esportati solo gli ordini che corrispondono ${criteria.join(" e ")}, nell'ordine della tabella.`;
}

export function ExportOrdersCsvModal({
  totalCount,
  search,
  hasFilters,
  allOrdersDescription,
  onExport,
  onClose,
}: {
  totalCount: number;
  search?: string;
  hasFilters: boolean;
  allOrdersDescription: string;
  onExport: () => Promise<void>;
  onClose: () => void;
}) {
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleExport = async () => {
    setError(null);
    setIsExporting(true);
    try {
      await onExport();
      onClose();
    } catch {
      setError("Errore durante l'esportazione. Riprova.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <OverlayDialog
      onClose={onClose}
      isClosable={!isExporting}
      panelClassName="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md flex flex-col gap-4"
    >
      <h2 className="text-xl font-bold">Esporta ordini</h2>
      <p className="text-sm text-gray-700">
        Stai per esportare <strong>{ordersLabel(totalCount)}</strong> in un file
        CSV.
      </p>
      <p className="text-xs text-gray-500">
        {describeSelection({ search, hasFilters, allOrdersDescription })}
      </p>
      {error && <p className="text-sm text-red-500">{error}</p>}
      <div className="flex gap-3 justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 rounded-lg text-sm border border-gray-300 hover:bg-gray-50"
        >
          Annulla
        </button>
        <PrimaryButton
          label={isExporting ? "Esportazione..." : "Scarica CSV"}
          onClick={handleExport}
          disabled={isExporting || totalCount === 0}
        />
      </div>
    </OverlayDialog>
  );
}
